module.exports = __webpack_public_path__ + "img/high.50997293.svg";